import careHomeAjax from '../../api/careHome'

const HOLIDAY_PLAN='HOLIDAY_PLAN';
const SAAS_SEARCH_CORP_INFO='SAAS_SEARCH_CORP_INFO';

//state
const state = {
	count: 10,
    addNumber:5,
    infos:{},
    holidayPlan:null,
    saasSearchCorpInfo: null
}
//getter
const getters = {
    doneTodosCount(state){
        return state.count
    },
    getAddNumber(state){
        return state.addNumber
    },
    getInfos(state){
        return state.infos
    },
    getEveryDay(state){
        return state.infos.information
    },
    getHolidayPlan(state){
        return state.holidayPlan;
    },
    saasSearchCorpInfo(state){
        return state.saasSearchCorpInfo;
    }
}

//actions
const actions = {
    addincrement ({ commit }, p) {
        commit('increment', p)
    },
    loadHomeDatas({ commit },params) {
      careHomeAjax.getHomeInfos(params,function(cdata){
            //alert( JSON.stringify(cdata.information.underway));
          commit('homeDate',{data:cdata})
      })
    },
    loadHolidayPlan({ commit },params) {
      careHomeAjax.getHolidayPlans(params,function(cdata){
            //alert( JSON.stringify(cdata.information.underway));
          commit(HOLIDAY_PLAN,{data:cdata})
      })
    },
	// 充值 查询公司来源
	saasSearchCorpInfo( {commit}, params ){
		careHomeAjax.saasSearchCorpInfo(params,function(cdata){
			commit(SAAS_SEARCH_CORP_INFO,{data:cdata});
		})
	},

}
//mutations
const mutations = {
    increment (state,p) {
        state.count = state.count+p;
    },
	homeDate(state, { data }){
        state.infos = data
    },
    [HOLIDAY_PLAN](state, { data }){
        state.holidayPlan=data
    },
	[SAAS_SEARCH_CORP_INFO](state, { data }){
		state.saasSearchCorpInfo = data;
	},
}
export default {
    state,
    getters,
    mutations,
    actions
}
